import type { DataHeatmapChart } from '@/shared/model';

/**
 * Single definition of the per-heatmap-key default builder. Converged from three
 * byte-identical copies (`RecoilEffect/recoilBeat/index.ts`,
 * `RecoilEffect/recoilHrSummary/index.ts` and a private clone in
 * `entities/report/model/reportStore.ts`) — read by three widgets and by
 * `reportStore`, so it belongs to no single entity. `shared` cannot import
 * `entities`, which also retires the circular-import reason the `reportStore`
 * clone was created for.
 */

/**
 * Seeds every beat-morphology series of a heatmap with the same initial value. Fills the N, S, V, qToQ and qToNSV keys with the supplied data.
 *
 * @param data - Value each series starts from.
 * @returns A heatmap state object with all five series set to the supplied value.
 */
export const generateDefaultHeatmapState = <Type>(data: Type): DataHeatmapChart<Type> => ({
  N: data,
  S: data,
  V: data,
  qToQ: data,
  qToNSV: data,
});
